import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const CATEGORY = actionTypes.GLOBAL_STATE

const categorySlice = createSlice({
  name: CATEGORY,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.category.pending, state => {
        state[actionTypes.CATEGORY].loading = true
      })
      .addCase(actionCreators.category.rejected, (state, action) => {
        state[actionTypes.CATEGORY].loading = false
        state[actionTypes.CATEGORY].error = action.payload as AxiosError
      })
      .addCase(actionCreators.category.fulfilled, (state, action) => {
        state[actionTypes.CATEGORY].loading = false
        state[actionTypes.CATEGORY].error = null
        state[actionTypes.CATEGORY].data = action.payload
      })

    builder
      .addCase(actionCreators.categoryAll.pending, state => {
        state[actionTypes.CATEGORY_ALL].loading = true
      })
      .addCase(actionCreators.categoryAll.rejected, (state, action) => {
        state[actionTypes.CATEGORY_ALL].loading = false
        state[actionTypes.CATEGORY_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.categoryAll.fulfilled, (state, action) => {
        state[actionTypes.CATEGORY_ALL].loading = false
        state[actionTypes.CATEGORY_ALL].error = null
        state[actionTypes.CATEGORY_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.categoryCreate.pending, state => {
        state[actionTypes.CATEGORY_CREATE].loading = true
      })
      .addCase(actionCreators.categoryCreate.rejected, (state, action) => {
        state[actionTypes.CATEGORY_CREATE].loading = false
        state[actionTypes.CATEGORY_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.categoryCreate.fulfilled, (state, action) => {
        state[actionTypes.CATEGORY_CREATE].loading = false
        state[actionTypes.CATEGORY_CREATE].error = null
        state[actionTypes.CATEGORY_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.categoryDelete.pending, state => {
        state[actionTypes.CATEGORY_DELETE].loading = true
      })
      .addCase(actionCreators.categoryDelete.rejected, (state, action) => {
        state[actionTypes.CATEGORY_DELETE].loading = false
        state[actionTypes.CATEGORY_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.categoryDelete.fulfilled, (state, action) => {
        state[actionTypes.CATEGORY_DELETE].loading = false
        state[actionTypes.CATEGORY_DELETE].error = null
        state[actionTypes.CATEGORY_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.categoryList.pending, state => {
        state[actionTypes.CATEGORY_LIST].loading = true
      })
      .addCase(actionCreators.categoryList.rejected, (state, action) => {
        state[actionTypes.CATEGORY_LIST].loading = false
        state[actionTypes.CATEGORY_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.categoryList.fulfilled, (state, action) => {
        state[actionTypes.CATEGORY_LIST].loading = false
        state[actionTypes.CATEGORY_LIST].error = null
        state[actionTypes.CATEGORY_LIST].data = action.payload
      })

    builder.addCase(actionCreators.categoryAllClear, state => {
      state[actionTypes.CATEGORY_ALL] = defaultState()
    })

    builder.addCase(actionCreators.categoryListClear, state => {
      state[actionTypes.CATEGORY_LIST] = defaultState()
    })
  },
})

export const { reducer: categoryReduser } = categorySlice
